import { Container, GridItem, Stack } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyBought } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyBought
}

export function DynamicEnergyBought({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 7, xl: 5 }}
            gridColumnStart={{ base: 1, xl: 3 }}
            gridRowEnd={{ base: 8, xl: 6 }}
            gridColumnEnd={{ base: 3, xl: 5 }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Container
                    position="relative"
                    zIndex={1}
                >
                    <Stack
                        flexDirection="column"
                        gap="none"
                    >
                        <Text>{blok.line1}</Text>
                        <Stack
                            alignItems="end"
                            gap="xs"
                        >
                            <AnimatedNumber
                                target={blok.amount}
                                final={blok.amount}
                            />
                            <Text showcased>{blok.line2}</Text>
                        </Stack>
                    </Stack>
                </Container>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyBought
